import {FC} from 'react';
import {View} from '@react-pdf/renderer';
import Table from './Table';
import {IPDFPCleanUp} from '../../../models/pdfReport';
import {coordinatesToString} from '../../../utils/cordinates_helpers';
import {durationToString} from '../../../utils/date_helpers';

interface IProps {
    data: IPDFPCleanUp;
}

const LocationBasicInfo: FC<IProps> = ({data}) => {
    const coordinates = coordinatesToString(data.location);
    const duration = durationToString(data.duration);

    const formater = new Intl.NumberFormat('en', {maximumFractionDigits: 3});

    const rows = [
        coordinates !== '-' ? {title: 'Coordinates', info: coordinates} : null,
        data.activityName ? {title: 'Linked Activity', info: data.activityName} : null,
        data.num_of_participant ? {title: 'Number of Participants', info: data.num_of_participant} : null,
        data.area ? {title: 'Area', info: `${formater.format(data.area)} m^2`} : null,
        data.length ? {title: 'Length', info: `${formater.format(data.length)} m`} : null,
        duration ? {title: 'Duration', info: duration} : null,
        data.substrateTitle ? {title: 'Substrate', info: data.substrateTitle} : null,
        data.siteTypeNames.length > 0 ? {title: 'Site Types', info: data.siteTypeNames.join(', ')} : null,
        data.additionalLocationInfoNames.length > 0 ? {title: 'Location Info', info: data.additionalLocationInfoNames.join(', ')} : null,
        data.creatorName ? {title: 'Added By', info: data.creatorName} : null,
    ].filter((row): row is {title: string; info: string} => row !== null);

    if (rows.length === 0) return null;

    return (
        <View>
            <Table title="BASIC INFO" mode="grid" rows={rows} />
        </View>
    );
};

export default LocationBasicInfo;
